export const renderDate = () => {
    const date = new Date()
    const days = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
    const months = date.getMonth()+1 < 10 ? `0${date.getMonth()+1}` : date.getMonth()+1
    const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
    return `${days}${months}${date.getFullYear()}_${hours}${minutes}${seconds}`
}